module.exports = __webpack_public_path__ + "images/hoagwhite.png";


//////////////////
// WEBPACK FOOTER
// ./assets/hoagwhite.png
// module id = 5
// module chunks = 0